import React from "react";

import { InputField } from "basics";

import { FilterContainer } from "components/ToolBar/styles";

// La galería guarda el año en `title`: el segundo filtro que había acá pegaba
// contra un campo `year` que los documentos no tienen, así que sólo podía
// devolver "Sin resultados".
export default function GalleryToolbar({ updateFiltering }) {
  const handleYearFilter = (field, value) => {
    updateFiltering(field, "equals", value.length === 4 ? value : undefined);
  };

  return (
    <FilterContainer>
      <InputField
        label="Filtrar por año"
        inputmode="numeric"
        type="number"
        id="title"
        placeholder="ingrese un año válido"
        onChange={handleYearFilter}
      />
    </FilterContainer>
  );
}
